module.exports = __webpack_public_path__ + "static/img/audio.14e27d06.png";